module.exports = __webpack_public_path__ + "img/moren-shitang-pic@2x.b72e79ef.png";